import { api } from '@/services/apiService'

import type { LeaderStudent } from '@/store/types'

export const universityService = {
  async fetchLeaderStudents() {
    const url = '/university/leader-student/'
    return api.get<LeaderStudent[]>(url)
  },
}
